//TODO: https://uberall.atlassian.net/browse/REP-5098
/* istanbul ignore file -- @preserve */
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { SurveyAPI } from '../survey';
import { SubmitSurveyFormResponse, SubmitSurveyFormResponsePayload } from '../../types/survey';

export const useSubmitSurveyResponse = (
    options?: UseMutationOptions<SubmitSurveyFormResponse, Error, SubmitSurveyFormResponsePayload>
) => {
    return useMutation<SubmitSurveyFormResponse, Error, SubmitSurveyFormResponsePayload>({
        mutationFn: SurveyAPI.submitSurveyForm,
        ...options,
    });
};
